// extracted by mini-css-extract-plugin
export default {"container":"Credits_container__FyvU7","tableContainer":"Credits_tableContainer__JUL1U"};